module.exports = __webpack_public_path__ + "static/media/tanakh.b5501a1a.svg";